<template lang="pug">
  agv-articles-list(:articles="articles"
    v-show="loaded"
    :filtered-articles-count="meta.filtered_count"
    :renter="page.type === 'renter' ? renter : null"
    :magnetArticle="showMagnet ? magnetArticle : null"
    :show-discounts="isCustomerProfessional"
    :is-wide="page.type === 'renter'"
    :get-is-advertising="isAdvertising"
    :is-loading-articles="isLoadingArticles"
    :show-ordering="!!articles.length && !(isPopularArticlesPage || isFavoritesPage || isLikedPage || isNewArticlesPage || (page.type === 'ad_banner'))"
    :show-articles="!!articles.length"
    :show-created-at="isNewArticlesPage"
    :show-banner="(page.type === 'catalog') || isLikedPage || isNewArticlesPage || !!(page.type === 'search' && meta.dominant_kind_id)"
    :show-only-new-banners="isNewArticlesPage"
    :dominant-aggregator-kind-id="meta.dominant_kind_id"
    ref="agvArticlesList"
    @orderingChanged="onOrderingChanged"
    @loadMore="onLoadMore")
    div(slot="title")
      h2(v-if="page.type === 'renter'" style="font-size:18px; margin-top: 10px; margin-right: 20px;")
        | {{kind.name | capitalize}}
      h1.page-title(v-else)
        span.title
          | {{title | capitalize}}
    div(slot="above-title" v-if="page.type === 'renter'")
      h1.page-title.page-title_top
        router-link.title(:to="`/${town_id}/renter/${renter_id}`" style="color: black;")
          | {{title | capitalize}}
        agv-rating(:rating="renter.avg_rating" :rating-count="renter.rating_count")
      .back-link
        agv-breadcrumbs(style="margin-top: 14px; margin-bottom: 20px;" :show-arrow="true" :items="[{name: 'Назад к категориям', url: `/${town_id}/renter/${renter_id}`}]")
    agv-side-navigation.left-sidebar(slot="left-sidebar"
      v-if="page.type !== 'renter' && !isPopularArticlesPage"
      :categories="navCategories"
      :show-favorites="customerHasFavorites"
      :show-liked="customerHasLikedArticles || customerHasLikedAdBanners")
    div(v-if="!articles.length && page.type === 'search'" slot="warning")
      .not-found-warning
        | Ничего не нашлось.
        br
        br
        | Попробуйте ввести синоним или обобщающее слово.
        | Не сработало — значит, нужных изделий на Пифаките пока нет.
        br
        | Если найдете их за пределами Пифакита, посоветуйте хозяину
        |
        a(href='/signup')
          | разместиться
        |
        | и получать заказы.
    .agv-articles-sidebar.right-sidebar.noselect(v-if="articles.length" slot="right-sidebar")
      agv-filter-remove-button(@click='clearFilters'
        :style="{visibility: anyFilters ? 'visible' : 'hidden'}")
      .filter-block(v-if='availableColors.length' style='margin-bottom: 0; padding-bottom: 4px;')
        .filter-block-title Цвет
        agv-color-filter(:color-options="availableColors"
          :active-colors="activeColors"
          :checked-colors="checkedColors"
          @toggle="toggleColor"
          :is-compact="true")
      div(v-if="page.type === 'list'")
        agv-filter-block(name="Категория"
          :tags="availableKinds"
          :active-tag-ids="activeKindIds"
          :checked-tag-ids="checkedKindIds"
          :show-thumbnails="false"
          @toggle="toggleKind")
      template(v-else)
        component(v-for="group in filterGroups"
          :is="filterGroups.length > 1 ? 'details' : 'div'"
          class="filter-group"
          :key="group.kind_id"
          :open="filterGroups.length > 1 && group.kind_id === activeFilterKindId")
          summary.filter-group__title(v-if="filterGroups.length > 1")
            span {{ (kindsById[group.kind_id] && kindsById[group.kind_id].name) | capitalize }}
            span.filter-group__arrow
          div(v-if="page.type === 'catalog' || page.type === 'renter' || page.type === 'search'")
            agv-filter-block(v-for="tagType in tagTypesForGroup(group)"
              :key="tagType.id"
              :name="tagType.name"
              :tags="tagType.availableTags"
              :active-tag-ids="tagType.activeTagIds"
              :checked-tag-ids="checkedTagIdsForGroup(group)"
              :show-thumbnails="tagType.show_thumbnails"
              @toggle="toggleTag")
</template>

<script>
import axios from 'axios'
import qs from 'querystring'

import Vue from 'vue'

import AgvFilterRemoveButton from 'Aggregator/components/agv-filter-remove-button'
import AgvColorFilter from 'Aggregator/components/agv-color-filter'
import AgvFilterBlock from 'Aggregator/components/agv-filter-block'
import AgvArticlesList from 'Aggregator/components/agv-articles-list'
import AgvSideNavigation from 'Aggregator/components/agv-side-navigation'
import {renderMetaForComponent} from 'Aggregator/meta'
import AgvBreadcrumbs from "Aggregator/components/agv-breadcrumbs.vue";
import AgvRating from "Aggregator/components/agv-rating.vue";
import _ from "lodash";

export default Vue.extend({
  name: 'page-agv-list',
  components: {
    AgvBreadcrumbs,
    AgvFilterBlock,
    AgvArticlesList,
    AgvColorFilter,
    AgvFilterRemoveButton,
    AgvSideNavigation,
    AgvRating,
  },
  metaInfo() {
    return {
      titleTemplate: `%s | Пифакит`,
      title: this.metaTitle,
      meta: [{vmid: 'description', name: 'description', content: this.metaDescription}]
    }
  },
  data() {
    return {
      loaded: false,
      articles: [],
      meta: {colors: [], tag_ids: [], filtered_count: 0, filter_groups: []},
      isLoadingArticles: true,
      kindsById: _.keyBy(this.$store.state.kinds, 'id'),
      aggregatorTagTypes: this.$store.state.aggregatorTagTypes,
      tagsByKindId: this.$store.state.tagsByKindId,
      offset: 0,
      ordering: null,
      magnetArticle: null,
      adBanner: null,
      activeKindId: null
    }
  },
  computed: {
    town_id() {
      return this.$route.params.town_id
    },
    town() {
      return this.$store.getters.town
    },
    metaTitle() {
      return renderMetaForComponent(this, 'title')
    },
    metaDescription() {
      return renderMetaForComponent(this, 'description')
    },
    metaState() {
      return {
        town: this.town,
        kind: this.kind
      }
    },
    checkedKindIds() {
      return this.tagHashFromList(this.kind_ids) || {}
    },
    customerHasFavorites() {
      return _.get(this.$store.state.customer.current, 'has_favorites')
    },
    customerHasLikedArticles() {
      return _.get(this.$store.state.customer.current, 'liked_articles_count') > 0
    },
    customerHasLikedAdBanners() {
      return _.get(this.$store.state.customer.current, 'liked_ad_banners_count') > 0
    },
    navCategories() {
      return this.$store.getters.navCategories
    },
    // Get tag_ids directly from URL query parameters
    urlTagIds() {
      return this.$route.query.tag_ids ? this.$route.query.tag_ids.split('+').map(Number) : []
    },
    
    checkedTagIds() {
      return this.tagHashFromList(this.urlTagIds) || {}
    },
    checkedColors() {
      return this.tagHashFromList(this.colors) || {}
    },
    activeColors() {
      if (!this.meta.filter_except_colors) {
        return this.meta.colors
      }

      return this.meta.filter_except_colors
    },
    availableTags() {
      return _.flatMap(this.filterGroups, group => {
        const kindTags = this.getKindTags(group.kind_id)
        return _.filter(kindTags, t => _.includes(this.meta.tag_ids, t.id))
      })
    },

    // Filter groups from the API response, sorted by articles count (descending)
    filterGroups() {
      const groups = this.meta.filter_groups || []
      // Groups should already be sorted by SQL query, but ensure client-side sorting as fallback
      return _.orderBy(groups, 'articles_count', 'desc')
    },

    // Active kind ID (for expanded filter group)
    activeFilterKindId() {
      // If we have a specific kind_id from props, use that
      if (this.kind_id) return this.kind_id

      // If user has manually selected a kind, use that
      if (this.activeKindId) return this.activeKindId

      // If backend provided a dominant kind, use that
      if (this.meta.dominant_kind_id) return this.meta.dominant_kind_id

      // Otherwise fall back to the first filter group's kind_id
      return _.get(_.first(this.filterGroups), 'kind_id')
    },
    availableAggregatorTagTypes() {
      return _.filter(
        this.aggregatorTagTypes,
        tt => _.find(this.availableTags, {aggregator_tag_type_id: tt.id})
      )
    },
    availableAggregatorTagTypesWithTags() {
      return _.map(
        _.orderBy(this.availableAggregatorTagTypes, 'position'),
        tt => {
          let idList = this.meta['filter_except_tag_ids_' + tt.id] || this.meta.tag_ids

          return _.merge({}, tt, {
            availableTags: _.filter(this.availableTags, {aggregator_tag_type_id: tt.id}),
            activeTagIds: _.fromPairs(_.map(idList, id => [id, true]))
          })
        }
      )
    },



    availableColors() {
      return _.filter(window.color_options, (o) => {
        return _.includes(this.meta.colors, o.value)
      })
    },
    kind() {
      if (!(this.kind_id)) {
        return null
      }
      return this.kindsById[this.kind_id]
    },
    navigationMethod() {
      return this.fromSearch ? 'search' : 'browsing'
    },
    dataQueryString() {
      let queryParams = _.merge(
        {colors: this.colors},
        this.dataOptionalQueryParams
      )

      queryParams = _.mapValues(queryParams, (p) => {
        return Array.isArray(p) ? p.join(' ') : p
      })

      if (this.offset) {
        queryParams.offset = this.offset
      }

      if (this.ordering) {
        queryParams.order_by = this.ordering
      }

      return qs.stringify(queryParams)
    },
    dataUrl() {
      return this.path + '?' + this.dataQueryString
    },
    isCustomerProfessional() {
      return !!_.get(this.$store.state.customer.current, 'is_professional')
    },
    showMagnet() {
      return this.page.type === 'catalog' &&
        !_.get(this.$store.state.customer.current, 'id')
    },
    title() {
      return this.page.getTitle(this)
    },
    dataOptionalQueryParams() {
      return this.page.getDataOptionalQueryParams(this)
    },
    path() {
      return this.page.getPath(this)
    },
    renter() {
      return this.$store.state.rentersById[this.renter_id]
    },
    theOnlyCheckedTag() {
      if (this.urlTagIds.length !== 1) {
        return null
      }

      // Look for the tag across all filter groups
      return _.find(this.availableTags, t => t.id === this.urlTagIds[0])
    },

    anyFilters() {
      return _.some([this.colors, this.urlTagIds, this.kind_ids], arr => arr && arr.length)
    },
    availableKinds() {
      return _.filter(this.$store.state.kinds, k => _.includes(this.meta.kind_ids, k.id))
    },
    activeKindIds() {
      let activeKindIds = this.meta.filter_except_kind_ids || this.meta.kind_ids
      return _.fromPairs(_.map(activeKindIds, kid => [kid, true]))
    }
  },
  methods: {
    // Helper method to get tags for any kind ID
    getKindTags(kindId) {
      return this.page.getKindTags(this, kindId) || []
    },

    replaceInPath(key, value) {
      return this.page.replaceInPath(this, key, value)
    },
    toggleKind(kind) {
      this.page.toggleKind(this, kind)
      // Update active kind ID when toggling kinds
      this.activeKindId = kind.id
    },

    // Get all tags for a specific filter group
    tagsForGroup(group) {
      if (!group || !group.kind_id) return []
      const kindTags = this.getKindTags(group.kind_id)
      return _.filter(kindTags, t => _.includes(group.tag_ids, t.id))
    },

    // Get tag types for a specific filter group
    tagTypesForGroup(group) {
      if (!group || !group.kind_id) return []

      const groupTags = this.tagsForGroup(group)
      const tagTypeIds = _.uniq(_.map(groupTags, 'aggregator_tag_type_id'))

      console.log(tagTypeIds)

      return _.map(
        _.orderBy(
          _.filter(this.aggregatorTagTypes, tt => _.includes(tagTypeIds, tt.id)),
          'position'
        ),
        tt => {
          // For filter groups, always show all tags as active (don't apply cross-group filtering)
          // Only apply filtering within the same group if there are selected tags in this group
          const currentGroupTagIds = this.checkedTagIdsForGroup(group)
          const hasSelectedTagsInGroup = _.some(currentGroupTagIds, _.identity)
          
          let activeTagIds
          if (hasSelectedTagsInGroup) {
            // If tags are selected in this group, use filter_except logic for this tag type only
            const idList = this.meta[`filter_except_tag_ids_${tt.id}`] || this.meta.tag_ids
            activeTagIds = _.fromPairs(_.map(idList, id => [id, true]))
          } else {
            // If no tags selected in this group, show all group tags as active
            activeTagIds = _.fromPairs(_.map(_.map(groupTags, 'id'), id => [id, true]))
          }

          return _.merge({}, tt, {
            availableTags: _.filter(groupTags, {aggregator_tag_type_id: tt.id}),
            activeTagIds: activeTagIds
          })
        }
      )
    },

    // Get checked tag IDs for a specific filter group
    checkedTagIdsForGroup(group) {
      if (!group || !group.kind_id) return {}
      
      // Filter tag_ids that belong to this group's kind_id
      const kindTags = this.getKindTags(group.kind_id)
      const kindTagIds = _.map(kindTags, 'id')
      
      // Use the urlTagIds computed property that reads directly from URL
      const relevantTagIds = _.filter(this.urlTagIds, id => _.includes(kindTagIds, id))
      return this.tagHashFromList(relevantTagIds) || {}
    },

    toggleTag(tag) {
      // Find which group this tag belongs to
      const tagKindId = this.findTagKindId(tag)
      if (!tagKindId) {
        // If we can't determine the group, use the default behavior
        this.page.toggleTag(this, tag)
        return
      }

      // Get all currently selected tag IDs
      let tagIds = _.clone(this.checkedTagIds)

      // If we're activating a tag (not deactivating)
      if (!tagIds[tag.id]) {
        // Clear tags from other groups
        const allKindTags = _.flatMap(this.filterGroups, group => {
          // Skip the current group
          if (group.kind_id === tagKindId) return []

          // Get all tags from other groups
          return this.getKindTags(group.kind_id)
        })

        // Remove any selected tags from other groups
        _.forEach(allKindTags, otherTag => {
          if (tagIds[otherTag.id]) {
            tagIds[otherTag.id] = false
          }
        })
      }

      // Toggle the current tag
      tagIds[tag.id] = !tagIds[tag.id]

      // Update the active kind ID to the group of this tag
      this.activeKindId = tagKindId

      // Update the URL with the new tag selection
      this.$router.push(this.replaceInPath('tag_ids', this.tagStringFromHash(tagIds)))
    },

    // Helper to find which kind_id a tag belongs to
    findTagKindId(tag) {
      for (const group of this.filterGroups) {
        const kindTags = this.getKindTags(group.kind_id)
        if (_.find(kindTags, { id: tag.id })) {
          return group.kind_id
        }
      }
      return null
    },
    onOrderingChanged(ordering) {
      this.offset = 0
      this.ordering = ordering
      this.fetchData()
    },
    onLoadMore() {
      this.offset += 42
      this.fetchData()
    },
    tagStringFromHash(tagIdsHash) {
      return _.keys(
        _.pickBy(tagIdsHash, _.identity)
      ).sort().join('+')
    },
    tagHashFromList(tagIdsList) {
      if (!_.get(tagIdsList, 'length')) {
        return {}
      }
      return _.reduce(tagIdsList, (obj, id) => {
        obj[id] = true
        return obj
      }, {})
    },
    isAdvertising(article, index) {
      if (!this.category) {
        return false
      }

      return index < 3 && !!(
        this.navigationMethod === 'browsing' && article.browsing_ad_position ||
        this.navigationMethod === 'search' && article.search_ad_position
      )
    },
    toggleColor(color) {
      let colors = _.clone(this.checkedColors)
      colors[color] = !this.checkedColors[color]
      this.$router.push(this.replaceInPath('colors', this.tagStringFromHash(colors)))
    },
    fetchData() {
      if (this.ad_banner_id) {
        axios.get(`/api/ab/${this.ad_banner_id}`).then(({data}) => {
          this.adBanner = data
          console.log(this.adBanner)
        })
      }

      this.isLoadingArticles = true

      const resetArticles = this.offset === 0
      axios.get(this.dataUrl).then(({data: {articles: loadedArticles, meta}}) => {
        if (resetArticles) {
          this.articles = loadedArticles
          this.magnetArticle = null
        } else {
          this.articles = this.articles.concat(loadedArticles)
        }
        Vue.set(this, 'meta', meta)
        this.$emit('loaded')
        this.isLoadingArticles = false
        this.loaded = true

        if (resetArticles && this.page.type === 'catalog') {
          // Find the first tag from the current active kind's tags
          const activeGroup = _.find(this.filterGroups, { kind_id: this.activeFilterKindId }) || _.first(this.filterGroups)
          const kindTags = activeGroup ? this.getKindTags(activeGroup.kind_id) : []

          const firstTag = _.first(
            _.orderBy(
              _.filter(kindTags, t => _.includes(activeGroup ? activeGroup.tag_ids : this.meta.tag_ids, t.id)),
              'compound_position'
            )
          )
          if (firstTag) {
            // Use the active kind ID for the magnet request
            const kindId = activeGroup ? activeGroup.kind_id : this.kind_id
            axios.get(
              `/api/articles/${this.town_id}/magnet/${kindId}?tag_ids_1=${firstTag.id}`
            ).then(({data: article}) => {
              this.magnetArticle = _.merge({isMagnet: true}, article)
            })
          } else {
            this.magnetArticle = _.merge({isMagnet: true}, _.first(_.orderBy(this.articles, 'usefulness', 'desc')))
          }
        }
      })
    },
    clearFilters() {
      this.$router.push(this.$route.path)
    },
  },
  props: {
    fromSearch: Boolean,
    colors: Array,
    kind_ids: Array,
    isFavoritesPage: Boolean,
    isPopularArticlesPage: Boolean,
    isLikedPage: Boolean,
    isNewArticlesPage: Boolean,
    renter_id: String,
    ad_banner_id: String,
    tag_ids: Array,
    kind_id: String,
    searchTerms: String,
    page: {
      type: Object,
      required: true
    }
  },
  watch: {
    $route(to, from) {
      if (!this.articles.length) {
        this.loaded = false
      }
      this.offset = 0
      this.ordering = null
      this.$refs.agvArticlesList.sortColumn = null
      this.$refs.agvArticlesList.sortDirection = null
      
      // Reset active kind when URL path changes (but not when only query params change)
      if (from && to.path !== from.path) {
        this.activeKindId = null
      }
      
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
})
</script>

<style scoped>
.agv-articles {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}

.filter-group {
  margin-bottom: 10px;
  overflow: hidden;
}

.filter-group__title {
  display: flex;
  font-size: 14px;
  color: rgb(91, 81, 81);
  justify-content: space-between;
  align-items: center;
  padding: 30px 12px 10px 0;
  font-weight: 500;
  cursor: pointer;
  border-top: 1px solid #ddd;
}

.filter-group__title:hover {
  color: rgb(124, 116, 116);
}

.filter-group__title::-webkit-details-marker {
  display: none;
}

.filter-group__arrow {
  position: relative;
  width: 12px;
  height: 12px;
}

.filter-group__arrow:before,
.filter-group__arrow:after {
  content: '';
  position: absolute;
  background-color: #666;
  transition: transform 0.25s ease;
}

.filter-group__arrow:before {
  width: 2px;
  height: 12px;
  top: 0;
  left: 5px;
}

.filter-group__arrow:after {
  width: 12px;
  height: 2px;
  top: 5px;
  left: 0;
}

.filter-group[open] .filter-group__arrow:before {
  transform: rotate(90deg);
}

/* Add some spacing between filter blocks */
.filter-group .filter-block {
  margin-top: 8px;
}

.not-found-warning {
  color: grey;
  display: block;
  font-size: 14px;
  margin-left: 6px;
}

.left-sidebar {
  padding-top: 13px;

  grid-column-start: 1;
  grid-column-end: 2;

  grid-row-start: 1;
  grid-row-end: 10000;
}

.right-sidebar {
  padding-left: 40px;
  padding-top: 16px;

  grid-column-start: -2;

  grid-row-start: 2;
  grid-row-end: 10000;

  position: relative;
}

.btn-filter-remove {
  position: absolute;
  top: -29px;
  right: 0;
}

.agv-filter-block {
  margin-bottom: 40px;
  margin-top: 10px;
}

.back-link {
  font-size: 14px;
  display: inline-block;
}

.title {
  margin-right: 20px;
}

.page-title >>> .agv-rating {
  font-size: 12px;
  display: inline-block;
  margin-top: 14px;
  margin-right: 20px;
}

.page-title >>> .agv-star-rating {
  margin-right: 0.4em;
  display: inline-block;
}

.page-title >>> .rating-count {
  font-weight: normal;
  display: inline-block;
}
</style>
